import { Col, Container, Row } from 'react-bootstrap';
import DoctorProfile from '../components/DoctorProfile';
import PatientProfile from '../components/PatientProfile';
import PatientInfoAccordion from './myappts/PatientInfoAccordion';
import FeedbackComponent from './feedback/FeedbackComponent';
import { useParams } from 'react-router-dom';
import { FC, useEffect, useRef, useState } from 'react';

const FeedbackView: FC = () => {
  const params = useParams<{ id: string; booking: string; edit: string }>();
  const docProfileElem = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<string | undefined>();

  useEffect(() => {
    if (!docProfileElem.current) return;
    const resizeObserver = new ResizeObserver(() => {
      setHeight(docProfileElem.current.clientHeight + 'px');
    });
    resizeObserver.observe(docProfileElem.current);
    return () => resizeObserver.disconnect();
  }, []);
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="text-center align-middle mb-3 mt-5">
          <h5>Video Call Feedback</h5>
        </Col>
      </Row>
      <Row className="justify-content-center align-middle pt-1 pb-1">
        <Col xs={12} sm={12} md={12} lg={3}>
          <div ref={docProfileElem} className="w-100">
            <DoctorProfile />
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} lg={5}>
          <PatientProfile addBorder={false} patientId={params.id} />
          <PatientInfoAccordion addBorder={false} patientId={params.id!} />
        </Col>
        <Col style={{ height }} xs={12} sm={12} md={12} lg={4}>
          <FeedbackComponent
            bookingId={params.booking}
            edit={params.edit === 'edit'}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default FeedbackView;
